import { observable, computed, action } from 'mobx';
import { API_URL, DATE_FORMAT, API_URL_MIDDLEWARE } from '../constants/constants';
import { CompanyStore } from './CompanyStore';
import { NotificationStore } from './NotificationStore';
import { NAVOrder } from '../models/interfaces';

class OrderHistoryStore {

  @observable
  public requesting: boolean;

  @observable
  private orders: Array<NAVOrder>;

  private companyStore: CompanyStore;
  private notificationStore: NotificationStore;

  constructor(
    orders: Array<NAVOrder> = [],
    companyStore: CompanyStore,
    notificationStore: NotificationStore
  ) {
    this.orders = orders;
    this.companyStore = companyStore;
    this.notificationStore = notificationStore;
    this.requesting = false;
  }

  @computed
  get orderList() {
    return this.orders;
  }

  @action
  async fetchOrders() {
    this.requesting = true;
    const token = localStorage.getItem('token');
    const company = this.companyStore.selectedCompany;
    const url = `${API_URL}/v1/user-orders?company=${company}`;
    const payload = { type: 'getOrders', company: company };

    const headers = new Headers();
    headers.append('Content-type', 'application/json');
    headers.append('X-CSRF-TOKEN', `${token}`);

    const ordersData = await fetch(url, {
      headers: headers,
      method: 'GET',
      credentials: 'include'
    })
      .then(res => res.json())
      .catch(err => {
        const error = {
          type: 'error',
          message: err.message + ': Asiakkaita ei voitu hakea.',
          seen: false
        };

        this.notificationStore.addNotification(error);
        return { error: err };
      });

    if (ordersData.error) {
      // show error
    } else {
      this.orders = ordersData;
    }

    this.requesting = false;
  }
}

export default OrderHistoryStore;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/OrderHistoryStore.ts